import { loadersSelector, messagesSelector } from './root';
import { propNameSelector } from '../utils';

export const messagesChanelsSelector = propNameSelector(messagesSelector, 'chanels');
export const messagesSendedSelector = propNameSelector(messagesSelector, 'sended');
export const messagesDeletedSelector = propNameSelector(messagesSelector, 'deleted');
export const messagesNewMessageSelector = propNameSelector(messagesSelector, 'newMessage');
export const loaderMessagesSelector = propNameSelector(loadersSelector, 'message');
export const loaderChanelsSelector = propNameSelector(loadersSelector, 'chanels');